import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./heroslider.css";
const slides = [
    {
        bg: "/images/slider-img/hero-1.png",
        titleLines: ["India's Leading Loan", "Financial Services Platform"],
        description:
            "Connect with 100+ banking partners for Home Loans, Personal Loans, Business Loans, Credit Cards, Insurance and more. Get best rates with instant eligibility check and digital document submission.",
        primaryBtn: {
            text: "Check Eligibility",
            link: "/coming",
        },
        secondaryBtn: {
            text: "Check CIBIL Score",
            link: "/cibil",
        },
    },
    {
        bg: "/images/slider-img/home-loan.jpg",
        titleLines: ["Affordable Home Loans", "Make Your Dream Home a Reality"],
        description:
            "Get home loans at attractive interest rates with flexible tenure and quick approvals. Compare offers from top banks and NBFCs with minimal paperwork and seamless digital processing.",
        primaryBtn: {
            text: "Apply for Home Loan",
            link: "/home-loan",
        },
        secondaryBtn: {
            text: "Check Home Loan EMI",
            link: "/home-loan-emi",
        },
    },
    {
        bg: "/images/slider-img/personal-loan.jpg",
        titleLines: ["Instant Personal Loans", "Quick Approval & Easy EMIs"],
        description:
            "Avail personal loans with minimal documentation, fast approval, and flexible EMIs. Get funds for medical, travel, education, or emergencies.",
        primaryBtn: {
            text: "Apply for Personal Loan",
            link: "/personal-loan",
        },
        secondaryBtn: {
            text: "Calculate EMI",
            link: "/emi-calculator",
        },
    },

    {
        bg: "/images/slider-img/insurance.jpg",
        titleLines: ["Protect What Matters Most", "Smart Insurance Solutions"],
        description:
            "Compare health, life, motor, and general insurance plans. Secure your family’s future with affordable premiums and maximum coverage.",
        primaryBtn: {
            text: "Explore Insurance Plans",
            link: "/insurance",
        },
        secondaryBtn: {
            text: "Compare Policies",
            link: "/compare-insurance",
        },
    },

    {
        bg: "/images/slider-img/car-loan.jpg",
        titleLines: ["Drive Your Dream Car", "Hassle-Free Car Loans"],
        description:
            "Get car loans at attractive interest rates with quick approval for new and used cars. Flexible tenure and easy repayment options.",
        primaryBtn: {
            text: "Apply for Car Loan",
            link: "/car-loan",
        },
        secondaryBtn: {
            text: "Check EMI Options",
            link: "/car-loan-emi",
        },
    },
    {
        bg: "/images/slider-img/crm.jpg",
        titleLines: ["Powerful Website & CRM", "Built for Financial Growth"],
        description:
            "Launch high-performance websites and CRM solutions to manage leads, automate processes, and grow your financial services business.",
        primaryBtn: {
            text: "Request a Demo",
            link: "/crm-demo",
        },
        secondaryBtn: {
            text: "View Features",
            link: "/crm-features",
        },
    },
    {
        bg: "/images/slider-img/real-estate.png",
        titleLines: ["Smart Real Estate Solutions", "Built to Sell Faster"],
        description:
            "Manage property listings, capture high-quality leads, schedule site visits, and close deals faster with an all-in-one real estate CRM and website platform.",
        primaryBtn: {
            text: "Get Started",
            link: "/real-estate-demo",
        },
        secondaryBtn: {
            text: "Explore Solutions",
            link: "/real-estate-features",
        },
    }

];


const HeroSlider = () => {
    const navigate = useNavigate();
    const [currentSlide, setCurrentSlide] = useState(0);

    /* Auto slide */
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    return (
        <section id="home" className="hero">
            <div
                className="hero-slide"
                style={{
                    backgroundImage: `url(${slides[currentSlide].bg})`,
                }}
            >
                <div className="hero-overlay"></div>

                <div className="hero-content home-page animated" key={currentSlide}>
                    <h1>
                        {slides[currentSlide].titleLines.map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </h1>

                    <p>{slides[currentSlide].description}</p>

                    <div className="hero-buttons">
                        {
                            slides[currentSlide].primaryBtn.text && (
                                <button
                                    className="cta-button"
                                    onClick={() =>
                                        navigate(slides[currentSlide].primaryBtn.link)
                                    }
                                >
                                    {slides[currentSlide].primaryBtn.text}
                                </button>
                            )
                        }
                        {
                            slides[currentSlide].secondaryBtn.text && (
                                <button
                                    className="secondary-button"
                                    onClick={() =>
                                        navigate(slides[currentSlide].secondaryBtn.link)
                                    }
                                >
                                    {slides[currentSlide].secondaryBtn.text}
                                </button>
                            )
                        }
                    </div>
                </div>

                {/* Dots */}
                <div className="hero-dots">
                    {slides.map((_, index) => (
                        <span
                            key={index}
                            className={`dot ${index === currentSlide ? "active" : ""}`}
                            onClick={() => setCurrentSlide(index)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HeroSlider;
